import dayjs from "dayjs";

/**
 * SIMS-8934 — the timestamp shown on every Activity Sidebar card.
 *
 * All three lists (Today's Activities, Delayed/Missed, Input Submitted) used to
 * carry their own copy of `dayjs(iso).format("hh:mm A")`. Time alone was
 * correct under SIMS-7632's assumption that these rows are all from today, but
 * none of the three queries filters by date — a pending call or an overdue
 * activity from last week renders as "09:14 AM" and reads as this morning.
 *
 * The PO's decision is to show the day ALWAYS, including for today's rows,
 * rather than only when the row is stale — one consistent shape is easier to
 * scan than a format that changes meaning depending on the date.
 *
 * `MM/DD/YYYY` is the app's dominant display format (17 call sites vs 11 for
 * ISO), and the 12-hour time is unchanged from the approved design — this adds
 * the date and alters nothing else.
 *
 * @param fallback what to render when there is no timestamp. Deliberately a
 * parameter: Delayed/Missed shows an em dash in its planned-time column, while
 * the other two render nothing at all.
 */
export const formatSidebarTimestamp = (
	iso: string | null,
	fallback = "",
): string => (iso ? dayjs(iso).format("MM/DD/YYYY hh:mm A") : fallback);
